import * as RadioGroupRadix from '@radix-ui/react-radio-group';
import { FC, useEffect, useState } from 'react';

import { RadioGroupItem } from './RadioGroupItem/RadioGroupItem';
import { API } from '~/shared/API/api';

interface Props {
  data: { img?: string; label: string; value: string; is_default?: boolean }[];
  type?: 'primary' | 'secondary';
}

export const RadioGroup: FC<Props> = ({ data, type = 'primary' }) => {
  const [activeValue, setActiveValue] = useState(
    data.find((i) => i.is_default)?.value
  );
  const [hovered, setHovered] = useState<string | null>(null);

  useEffect(() => {
    if (!activeValue) {
      API.setActiveCard(data[0].value);
      setActiveValue(data[0].value);
    }
  }, []);

  return (
    <>
      <RadioGroupRadix.Root
        value={activeValue}
        onValueChange={(value: string) => {
          setActiveValue(value);
          API.setActiveCard(value);
        }}>
        {data?.length
          ? data.map((item, index) => (
              <RadioGroupItem
                key={index}
                type={type}
                item={item}
                activeValue={activeValue}
                setActiveValue={setActiveValue}
                hovered={hovered}
                setHovered={setHovered}
              />
            ))
          : null}
      </RadioGroupRadix.Root>
    </>
  );
};
